export const EAuthority = {
  TRANSACTIONS: 'TRANSACTIONS',
  REVERT_TRANSACTION: 'REVERT_TRANSACTION',
  REVERT_TRANSFER: 'REVERT_TRANSFER',
  WALLET_SERVICES: 'WALLET_SERVICES',
  CREATE_WALLET_SERVICES: 'CREATE_WALLET_SERVICES',
  EDIT_WALLET_SERVICES: 'EDIT_WALLET_SERVICES',
  COMPANIES: 'COMPANIES',
  DOWNLOAD_COMPANIES: 'DOWNLOAD_COMPANIES',
  CREATE_COMPANIES: 'CREATE_COMPANIES',
  EDIT_BASIC_INFO_COMPANIES: 'EDIT_BASIC_INFO_COMPANIES',
  EDIT_COMPANIES: 'EDIT_COMPANIES',
  SHOPS: 'SHOPS',
  DOWNLOAD_SHOPS: 'DOWNLOAD_SHOPS',
  CREATE_SHOPS: 'CREATE_SHOPS',
  EDIT_PHONE_SHOPS: 'EDIT_PHONE_SHOPS',
  EDIT_SHOPS: 'EDIT_SHOPS',
  TERMINALS: 'TERMINALS',
  DOWNLOAD_TERMINALS: 'DOWNLOAD_TERMINALS',
  EDIT_TERMINALS: 'EDIT_TERMINALS',
  RESET_TERMINAL_PASSWORD: 'RESET_TERMINAL_PASSWORD',
  APP_USERS: 'APP_USERS',
  EDIT_APP_USERS: 'EDIT_APP_USERS',
  RESET_APP_USERS: 'RESET_APP_USERS',
  LOGIN_LOCK_APP_USERS: 'LOGIN_LOCK_APP_USERS',
  VALID_BANK_ACCOUNT: 'VALID_BANK_ACCOUNT',
  WITHDRAWAL_APP_USERS: 'WITHDRAWAL_APP_USERS',
  BALANCE_ADJUSTMENT: 'BALANCE_ADJUSTMENT',
  ADMIN_USERS: 'ADMIN_USERS',
  DOWNLOAD_ADMIN_USERS: 'DOWNLOAD_ADMIN_USERS',
  EDIT_ADMIN_USERS: 'EDIT_ADMIN_USERS',
  RESET_ADMIN_USER_PASSWORD: 'RESET_ADMIN_USER_PASSWORD',
  RESET_ADMIN_USER_PASSWORD_FOR_STAFF: 'RESET_ADMIN_USER_PASSWORD_FOR_STAFF',
  RESERVE_BULK_GRANTS: 'RESERVE_BULK_GRANTS',
  BULK_GRANTS: 'BULK_GRANTS',
  MASTER_UPLOADS: 'MASTER_UPLOADS',
  FILE_UPLOADS: 'FILE_UPLOADS',
  FILE_DOWNLOADS: 'FILE_DOWNLOADS',
  TEMP_USER: 'TEMP_USER',
  SHOP_CHARGE: 'SHOP_CHARGE',
  PREMIUM_GIFTS: 'PREMIUM_GIFTS',
  LOGIN_SHOP_APP: 'LOGIN_SHOP_APP',
  SETTLEMENTS: 'SETTLEMENTS',
  POLICY: 'POLICY',
  BANKPAY_TRANSACTIONS: 'BANKPAY_TRANSACTIONS',
  DOWNLOAD_BANKPAY_TRANSACTIONS: 'DOWNLOAD_BANKPAY_TRANSACTIONS',
  AGGREGATIONS: 'AGGREGATIONS',
  DOWNLOAD_AGGREGATIONS: 'DOWNLOAD_AGGREGATIONS',
  RESERVE_PREPAID_TOTAL_AGGREGATIONS: 'RESERVE_PREPAID_TOTAL_AGGREGATIONS',
  RESERVE_CHARGE_AGGREGATIONS: 'RESERVE_CHARGE_AGGREGATIONS',
  RESERVE_SETTLEMENT_AGGREGATIONS: 'RESERVE_SETTLEMENT_AGGREGATIONS',
  RESERVE_CAMPAIGN_BREAKDOWN_AGGREGATIONS: 'RESERVE_CAMPAIGN_BREAKDOWN_AGGREGATIONS',
  RESERVE_CAMPAIGN_AGGREGATIONS: 'RESERVE_CAMPAIGN_AGGREGATIONS',
  RESERVE_BULK_GRANT_AGGREGATIONS: 'RESERVE_BULK_GRANT_AGGREGATIONS',
  RESERVE_UNUSED_BALANCE_AGGREGATIONS: 'RESERVE_UNUSED_BALANCE_AGGREGATIONS',
  CAMPAIGNS: 'CAMPAIGNS',
  EDIT_CAMPAIGNS: 'EDIT_CAMPAIGNS',
  DOWNLOAD_TRANSACTIONS: 'DOWNLOAD_TRANSACTIONS',
  DOWNLOAD_APP_USERS: 'DOWNLOAD_APP_USERS',
  GIFTS: 'GIFTS',
  SETUP_TERMINALS: 'SETUP_TERMINALS',
  PHYSICAL_PREPAID_CARDS: 'PHYSICAL_PREPAID_CARDS',
  EDIT_PHYSICAL_PREPAID_CARDS: 'EDIT_PHYSICAL_PREPAID_CARDS',
  DOWNLOAD_PHYSICAL_PREPAID_CARDS: 'DOWNLOAD_PHYSICAL_PREPAID_CARDS',
} as const;

export type TAuthority = typeof EAuthority[keyof typeof EAuthority];
